"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    PopoverContent: ()=>PopoverContent
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const popover_namespaceObject = require("@base-ui-components/react/popover");
const index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const external_ScrollArea_index_cjs_namespaceObject = require("../ScrollArea/index.cjs");
const external_Text_index_cjs_namespaceObject = require("../Text/index.cjs");
function PopoverContent({ headingCustomSlot, headingCloseButtonSlot, headingLeftSlot, headingRightSlot, headingTextSlot, headingIconSlot, bodyTextSlot, renderCloseButton, headingCustomNode, headingText, headingIconName, headingRightNode, description, children, footer, headingClasses, scrollAreaClasses, contentClasses, bodyClasses, footerClasses }) {
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: contentClasses,
        children: [
            headingCustomNode ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(popover_namespaceObject.Popover.Title, {
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                    className: headingCustomSlot,
                    children: headingCustomNode
                })
            }) : headingText ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: headingClasses,
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                        className: headingLeftSlot,
                        children: [
                            headingIconName && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                                iconName: headingIconName,
                                size: "24",
                                className: headingIconSlot
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(popover_namespaceObject.Popover.Title, {
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                    className: headingTextSlot,
                                    children: headingText
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        className: headingRightSlot,
                        children: headingRightNode
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        className: headingCloseButtonSlot,
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(popover_namespaceObject.Popover.Close, {
                            render: ()=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                    children: renderCloseButton()
                                })
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_ScrollArea_index_cjs_namespaceObject.ScrollArea, {
                className: scrollAreaClasses,
                popoverBody: true,
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                        className: bodyClasses,
                        children: [
                            description && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(popover_namespaceObject.Popover.Description, {
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                                    className: bodyTextSlot,
                                    children: description
                                })
                            }),
                            children
                        ]
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        className: footerClasses,
                        children: footer
                    })
                ]
            })
        ]
    });
}
exports.PopoverContent = __webpack_exports__.PopoverContent;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "PopoverContent"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
